module.exports = __webpack_public_path__ + "media/images/game/pages/logo_rozpoctisito-34b9e78be9a03719b8e4f1fe163eb62d.png";